export default "__VITE_ASSET__CfEOk8T5__"